(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["lwr-client"] = factory();
	else
		root["lwr-client"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(166);


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FileUploader = exports.Client = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _client = __webpack_require__(167);
	
	var _upload = __webpack_require__(176);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 29.09.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var DEBUG = ("production") !== 'production';
	
	/**
	 *
	 * Custom @convotis/liferay-client extended for the Liferay-Widget-React-Framework (Lwr-Framework).
	 *
	 */
	
	var LwrLiferayClient = function (_LiferayClient) {
	    _inherits(LwrLiferayClient, _LiferayClient);
	
	    function LwrLiferayClient() {
	        _classCallCheck(this, LwrLiferayClient);
	
	        return _possibleConstructorReturn(this, _LiferayClient.apply(this, arguments));
	    }
	
	    LwrLiferayClient.prototype.invokeWithContext = function invokeWithContext(method, data, context) {
	
	        if (DEBUG) {
	            if (data) {
	                Object.keys(data).forEach(function (p) {
	                    if (typeof data[p] === 'undefined') {
	                        console.warn('Undefined param: ' + p);
	                    }
	                });
	            }
	        }
	
	        var v = {
	            'serviceContext': {
	                'scopeGroupId': lrClient.getScopeGroupId(),
	                'attributes': context
	            }
	        };
	        if (arguments.length > 2 && typeof context !== 'undefined') {
	            v.serviceContext.attributes = context;
	
	            v = _extends({}, v, data);
	        } else {
	            v.serviceContext.attributes = data;
	        }
	        return this.invoke(method, v);
	    };
	
	    LwrLiferayClient.prototype.getScopeGroupId = function getScopeGroupId() {
	        return Liferay.ThemeDisplay.getScopeGroupId();
	    };
	
	    LwrLiferayClient.prototype.invokeExternal = function invokeExternal(_ref) {
	        var baseUrl = _ref.baseUrl,
	            path = _ref.path,
	            _ref$params = _ref.params,
	            params = _ref$params === undefined ? {} : _ref$params,
	            _ref$headers = _ref.headers,
	            headers = _ref$headers === undefined ? {} : _ref$headers;
	
	        return new Promise(function (resolve, reject) {
	            var _JSON$stringify;
	
	            var invokePath = baseUrl + '/api/jsonws/invoke';
	            var reqData = 'cmd=' + JSON.stringify((_JSON$stringify = {}, _JSON$stringify[path] = params, _JSON$stringify));
	            fetch(invokePath, {
	                method: 'POST',
	                body: reqData,
	                headers: _extends({
	                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
	                }, headers)
	            }).then(function (response) {
	                if (response.ok) {
	                    resolve(response.json());
	                } else {
	                    reject(response.text());
	                }
	            });
	        });
	    };
	
	    return LwrLiferayClient;
	}(_client.LiferayClient);
	
	var lrClient = new LwrLiferayClient({
	    mobileApps: {
	        defaultAutoInstall: false,
	        defaultAutoInstallPush: false
	    },
	    useBasicAuth: false,
	    url: window.location.protocol + '//' + window.location.host
	});
	
	exports.Client = lrClient;
	exports.FileUploader = _upload.FileUploader;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _defineProperty(e,t,s){return t in e?Object.defineProperty(e,t,{value:s,enumerable:!0,configurable:!0,writable:!0}):e[t]=s,e}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(exports,"__esModule",{value:!0}),exports.LiferayClient=void 0;var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var s=arguments[t];for(var n in s)Object.prototype.hasOwnProperty.call(s,n)&&(e[n]=s[n])}return e},_createClass=function(){function e(e,t){for(var s=0;s<t.length;s++){var n=t[s];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,s,n){return s&&e(t.prototype,s),n&&e(t,n),t}}(),_base=__webpack_require__(168),_base2=_interopRequireDefault(_base),_errorLogging=__webpack_require__(170),_defaultLogger=__webpack_require__(172),_defaultStorage=__webpack_require__(173),_Constants=__webpack_require__(174),_utils=__webpack_require__(175),LiferayClient=exports.LiferayClient=function(){function e(t){var s=this;_classCallCheck(this,e),this.afterInit=function(){return s.initPromise||s.init()},this.getAccessToken=function(){return s.afterInit().then(function(){return s._getAccessToken()})},this.getState=function(){return s.activeState},this.getUser=function(){return s.session&&s.session.user},this.isGuestUser=function(){return s.getUser()&&s.getUser().isGuest},this.getServerUrl=function(){return s.options.url},this.invoke=function(e,t,n){return s.afterInit().then(function(){return s._invoke(e,t,n)})},this.login=function(e,t){return s.afterInit().then(function(){return s._login(e,t)})},this.logout=function(){return s.afterInit().then(function(){return s._logout()}).then(function(e){return s.trigger(_Constants.EVENTS.LOGOUT,e)}).catch(function(e){return s.logger.logError(e)})},this._foundLRSessionCookie=function(){return document&&document.cookie.indexOf("LFR_SESSION_STATE")>-1},this._getSession=function(){return s.session},this._onStateChanged=function(e,t){return s.logger.logInfo("State changes "+t+" --\x3e "+e)},this._getAuthToken=function(){return window&&window.Liferay&&window.Liferay.authToken},this.store=t.store||new _defaultStorage.DefaultStorage,this.logger=t.logger||new _defaultLogger.DefaultLogger,this.options=this._initOptions(t),this.activeState=_Constants.STATE.INIT,this.events={},this.logConsoleErrors=_errorLogging.ErrorLogger.logConsoleErrors.bind(this),this.buildStackTrace=_errorLogging.ErrorLogger.buildStackTrace.bind(this),this.sendEvent=_errorLogging.ErrorLogger.sendEvent.bind(this)}return _createClass(e,[{key:"_initOptions",value:function(e){return/^https?:\/\//i.test(e.url)||this.logger.logError("Missing protocol in "+e.url),/^http?:\/\//i.test(e.url)&&this.logger.logWarn("DON'T USE HTTP FOR PRODUCTION"),_extends({},_Constants.DEFAULT_OPTIONS,e)}},{key:"init",value:function(){var e=this;return this.initPromise||(this.logger.logInfo("Init liferay client",this.options),this.initPromise=this.store.getObject(_Constants.SESSION_KEY).then(function(t){return e._validatePrevSession(t)},function(){return e._validatePrevSession.bind(e,null)}).then(function(){return e.logger.logInfo("Init liferay client DONE",e.options),e._doNextState(_Constants.STATE.INITIALIZED),e.trigger(_Constants.EVENTS.INIT),e._init=!0}),this.options.autoSessionValidation&&(this.logger.logInfo("Start autoSessionValidation"),setInterval(function(){return e._validateCurrentSession()},1e4))),this.initPromise}},{key:"on",value:function(e,t){this.events[e]||(this.events[e]=[]),this.events[e].push(t)}},{key:"off",value:function(e,t){if(this.events[e])if(t){var s=this.events[e].indexOf(t);-1!==s&&this.events[e].splice(s,1)}else this.events[e]=[]}},{key:"trigger",value:function(e,t){this.logger.logInfo("Client trigger: "+e,t),this.events[e]&&this.events[e].forEach(function(e){return e(t)})}},{key:"toString",value:function(){var e=this._getSession();return e?"Session: "+(e.user.isGuest?"Guest":this.user.firstName+" "+this.user.lastName):"No Session"}},{key:"_validateCurrentSession",value:function(){var e=this;this.store.getObject(_Constants.SESSION_KEY).then(function(t){var s=e._getSession();if(s)if((s.user&&s.user.userId)!==(t&&t.user&&t.user.userId))e._refreshSession();else{s=t||s;var n=e.options.refreshSessionAfter||432e5,i=s.time?new Date-new Date(s.time):0;e.logger.logDebug("Session "+s.time+" is "+Math.round(i/1e3)+"s old"),i>n&&(s.time=new Date(new Date(s.time).getTime()+5e3),e.store.setObject(_Constants.SESSION_KEY,s),e._refreshSession())}})}},{key:"_validatePrevSession",value:function(e){var t=this;if(!e||!e.exception&&e.user||(this.logger.logError("previousSession is invalid! ",e),e=null),!e||e.user&&e.user.isGuest||e.url!==this.options.url)this._onNoValidPrevSession(e);else{this.logger.logInfo("Remember previous session: "+JSON.stringify(e)),this._doNextState(_Constants.STATE.REFRESH_PREVIOUS_SESSION_REQUESTED);var s=function(e){t._setSession(e),t._doNextState(_Constants.STATE.LOGGED_IN)};this._fetchSession(e.hash).then(s).catch(function(n){401===n.status?t._onNoValidPrevSession(e):(t.logger.logError("cannot revalidate previous session",e),s(e))})}}},{key:"_onNoValidPrevSession",value:function(e){this.options.isSessionRequired?(e&&this.logger.logError("previous session invalid!",e),this.session=null,this._doNextState(_Constants.STATE.NO_SESSION)):this.options.sessionSharing&&this._foundLRSessionCookie()?this._refreshSession():this._doNextState(_Constants.STATE.LOGGED_IN)}},{key:"_setSession",value:function(e){this.session=e,e&&(e.time=new Date),this.store.setObject(_Constants.SESSION_KEY,e)}},{key:"_getAccessToken",value:function(){var e=this;return this.session&&this.session.accessToken&&(new Date).getTime()+2e3>this.session.exp?(this.logger.logInfo("Acccess token expired! Fetching new token."),this._refreshSession().then(function(){return e.session&&e.session.accessToken}).catch(Promise.reject)):Promise.resolve(this.session&&this.session.accessToken)}},{key:"_doNextState",value:function(e){var t=this.activeState;this.activeState=e,this._onStateChanged(this.activeState,t),this.trigger(_Constants.EVENTS.STATE_CHANGED,this.activeState),e===_Constants.STATE.LOGGED_IN&&t!==_Constants.STATE.LOGGED_IN&&this.trigger(_Constants.EVENTS.LOGIN,this.getUser()),e===_Constants.STATE.NO_SESSION&&this.trigger(_Constants.EVENTS.NO_SESSION)}},{key:"_fetchSession",value:function(e){var t=this,s=!this.options.useBasicAuth&&this._getAuthToken();this.logger.logInfo("_fetchSession "+(this.options.useBasicAuth?" basicAuth ":"")+(e?" with auth hash":"without auth hash")+(s?" and auth token"+s:""));var n=new Promise(function(n,i){var o=new XMLHttpRequest;o.onreadystatechange=function(){if(4===o.readyState&&200===o.status){var s=(0,_utils.responseToJSON)(o.response),r=t._isInvalidSession(s);r?i(r):n(_extends({url:t.options.url,hash:e},s))}else 4===o.readyState&&i({statusText:o.statusText,status:o.status,request:o})},o.onerror=function(){i({statusText:o.statusText,status:o.status,request:o})},o.open("GET",t.options.url+t.options.loginServicePath+(s?"?p_auth="+s:""),!0),t.options.useBasicAuth&&e&&o.setRequestHeader("Authorization","Basic "+e);try{o.responseType="json"}catch(e){t.logger.logWarn("XMLHttpRequest.responseType = 'json' not supported.")}o.send()});return n.then(this.logger.logInfo.bind(null,"_fetchSession success"),this.logger.logError.bind(null,"_fetchSession fail")),n}},{key:"_isInvalidSession",value:function(e){return e?e.user?!this.options.guestIsValidSession&&e.user.isGuest?"guest session":null:"no session user":"no session"}},{key:"_refreshSession",value:function(){var e=this;return this._refreshPromise?this.logger.logDebug("_refreshPromise exists!"):(this.logger.logInfo("Refresh session"),this._refreshPromise=this._fetchSession(this._getAuthHash()).then(function(t){e._refreshPromise=null,e._setSession(t),e.getState()!==_Constants.STATE.LOGGED_IN&&e._doNextState(_Constants.STATE.LOGGED_IN)}).catch(function(t){e._refreshPromise=null,e.logger.logError("refresh session error",t),e._setSession(null),e._doNextState(_Constants.STATE.NO_SESSION)})),this._refreshPromise}},{key:"_login",value:function(e,t){var s=this;this._doNextState(_Constants.STATE.SESSION_REQUESTED);var n=this.options.useBasicAuth&&_base2.default.encode(e+":"+t);return this._fetchSession(n).then(function(e){s._setSession(e),s._doNextState(_Constants.STATE.LOGGED_IN)}).catch(function(e){s._doNextState(_Constants.STATE.NO_SESSION),s.trigger(_Constants.EVENTS.LOGIN_FAIL,e),s.logger.logError(e)})}},{key:"_logout",value:function(){this.logger.logInfo("logout: "+this._getSession()),this._setSession(null),this._doNextState(_Constants.STATE.NO_SESSION)}},{key:"_preValidateCredentials",value:function(e,t){return e&&t&&0!==e.length&&0!==t.length?null:_Constants.MESSAGES.please_enter_credentials}},{key:"_invoke",value:function(e,t,s){var n=this;return new Promise(function(i,o){try{var r=t,a=new XMLHttpRequest,u=n.options.url+"/api/jsonws";t instanceof FormData?(n.logger.logInfo("LiferayService.post formdata: "+e+" ("+JSON.stringify(t,void 0,"  ")+")"),u+=e):(n.logger.logInfo("LiferayService.invoke: "+e+" ("+JSON.stringify(t,void 0,"  ")+")"),u+="/invoke",r="cmd="+encodeURIComponent(JSON.stringify(_defineProperty({},e,t||{}))));var h=function(e,t){n.logger.logError(e,t,a),o({error:new Error(e),exception:t,request:a})},l=n;a.onreadystatechange=function(){if(4===this.readyState&&200===this.status){var e=(0,_utils.responseToJSON)(this.response);e&&e.error?h(e.error.message,e.error.type):i(e,this.statusText)}else if(4===this.readyState){401!==this.status&&403!==this.status||(l.logger.logWarn("Auth error "+this.status+" trigger refresh session"),l._refreshSession());var t=void 0;try{t=this.response&&(0,_utils.responseToJSON)(this.response)}catch(e){l.logger.logError(e)}t&&t.error?h(t.error.message,t.error.type):h(this.statusText)}},a.onerror=function(){h("XMLHttpRequest Error: "+this.statusText)},n.options&&n.options.useBasicAuth||(u=u+"?p_auth="+n._getAuthToken()),a.open("POST",u,!0);try{a.responseType="json"}catch(e){n.logger.logWarn("XMLHttpRequest.responseType = 'json' not supported.")}t instanceof FormData||a.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=UTF-8"),n._setAuth(a),s&&Object.keys(s).forEach(function(e){a.setRequestHeader(e,s[e])}),a.send(r)}catch(e){n.logger.logError(e),o(e)}})}},{key:"_setAuth",value:function(e){if(this.options&&this.options.useBasicAuth){e.withCredentials=!1;var t=this._getAuthHash();t&&(e.setRequestHeader?e.setRequestHeader("Authorization","Basic "+t):e.headers&&(e.headers.Authorization="Basic "+t))}else e.withCredentials=this.options.sessionSharing}},{key:"_getAuthHash",value:function(){var e=this._getSession();return e&&e.hash}}]),e}();
	//# sourceMappingURL=client.js.map


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)(module), (function() { return this; }())))

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var TraceKit=__webpack_require__(171),ErrorLogger=exports.ErrorLogger={logConsoleErrors:function(){function e(e,r,o,t,i){var n={message:e,url:r,lineNo:o,colNo:t,error:i||{}};n.stack=this.buildStackTrace(n),this.sendEvent(n)}try{window.onerror=e.bind(this)}catch(e){console.error(e)}},buildStackTrace:function(e){var r=void 0;return e.error?r=TraceKit.computeStackTrace(e.error):e.stack&&e.message?(r=TraceKit.computeStackTrace(e),e={}):r=null,r},sendEvent:function(e){var r=this.getDeviceInfo&&this.getDeviceInfo()||{},o=this.getAppConfig&&this.getAppConfig()||{},t={variantVersionKey:o.variantVersionKey||null,deviceUuid:r.deviceUuid||null,platform:r.platform||null,model:r.model||null,osVersion:r.version||r.osVersion||null,data:JSON.stringify(e)};this.invokeMobile(this.options.errorLoggingMethod,t).then(function(e){console.log("Result: ",e)})}};
	//# sourceMappingURL=error-logging.js.map


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/**
	 * https://github.com/csnover/TraceKit
	 * @license MIT
	 * @namespace TraceKit
	 */
	(function(window, undefined) {
	if (!window) {
	    return;
	}
	
	var TraceKit = {};
	var _oldTraceKit = window.TraceKit;
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	/**
	 * A better form of hasOwnProperty<br/>
	 * Example: `_has(MainHostObject, property) === true/false`
	 *
	 * @param {Object} object to check property
	 * @param {string} key to check
	 * @return {Boolean} true if the object has the key and it is not inherited
	 */
	function _has(object, key) {
	    return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	/**
	 * Returns true if the parameter is undefined<br/>
	 * Example: `_isUndefined(val) === true/false`
	 *
	 * @param {*} what Value to check
	 * @return {Boolean} true if undefined and false otherwise
	 */
	function _isUndefined(what) {
	    return typeof what === 'undefined';
	}
	
	/**
	 * Export TraceKit out to another variable<br/>
	 * Example: `var TK = TraceKit.noConflict()`
	 * @return {Object} The TraceKit object
	 * @memberof TraceKit
	 */
	TraceKit.noConflict = function noConflict() {
	    window.TraceKit = _oldTraceKit;
	    return TraceKit;
	};
	
	/**
	 * Wrap any function in a TraceKit reporter<br/>
	 * Example: `func = TraceKit.wrap(func);`
	 *
	 * @param {Function} func Function to be wrapped
	 * @return {Function} The wrapped func
	 * @memberof TraceKit
	 */
	TraceKit.wrap = function traceKitWrapper(func) {
	    function wrapped() {
	        try {
	            return func.apply(this, arguments);
	        } catch (e) {
	            TraceKit.report(e);
	            throw e;
	        }
	    }
	    return wrapped;
	};
	
	/**
	 * Cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 * ```js
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 * ```
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *     on top frame; column number is not guaranteed
	 *   - Opera: full stack trace with line and column numbers
	 *   - Chrome: full stack trace with line and column numbers
	 *   - Safari: line and column number for the top frame only; some frames
	 *     may be missing, and column number is not guaranteed
	 *   - IE: line and column number for the top frame only; some frames
	 *     may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a TraceKit.StackTrace object as described in the
	 * TraceKit.computeStackTrace docs.
	 *
	 * @memberof TraceKit
	 * @namespace
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     * @memberof TraceKit.report
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     * @memberof TraceKit.report
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	
	        if (handlers.length === 0) {
	            window.onerror = _oldOnerrorHandler;
	            _onErrorHandlerInstalled = false;
	        }
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {TraceKit.StackTrace} stack
	     * @param {boolean} isWindowError Is this a top-level window error?
	     * @param {Error=} error The error that's being handled (if available, null otherwise)
	     * @memberof TraceKit.report
	     * @throws An exception if an error occurs while calling an handler.
	     */
	    function notifyHandlers(stack, isWindowError, error) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (_has(handlers, i)) {
	                try {
	                    handlers[i](stack, isWindowError, error);
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error occurred.
	     * @param {(number|string)=} columnNo The column number at which the error occurred.
	     * @param {Error=} errorObj The actual Error object.
	     * @memberof TraceKit.report
	     */
	    function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	    	    processLastException();
	        } else if (errorObj) {
	            stack = TraceKit.computeStackTrace(errorObj);
	            notifyHandlers(stack, true, errorObj);
	        } else {
	            var location = {
	              'url': url,
	              'line': lineNo,
	              'column': columnNo
	            };
	
	            var name;
	            var msg = message; // must be new var or will modify original `arguments`
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
	            location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
	            stack = {
	                'name': name,
	                'message': msg,
	                'mode': 'onerror',
	                'stack': [location]
	            };
	
	            notifyHandlers(stack, true, null);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    /**
	     * Install a global onerror handler
	     * @memberof TraceKit.report
	     */
	    function installGlobalHandler() {
	        if (_onErrorHandlerInstalled === true) {
	            return;
	        }
	
	        _oldOnerrorHandler = window.onerror;
	        window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    /**
	     * Process the most recent exception
	     * @memberof TraceKit.report
	     */
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastException = lastException;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers(_lastExceptionStack, false, _lastException);
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @memberof TraceKit.report
	     * @throws An exception if an incomplete stack trace is detected (old IE browsers).
	     */
	    function report(ex) {
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    return report;
	}());
	
	/**
	 * An object representing a single stack frame.
	 * @typedef {Object} StackFrame
	 * @property {string} url The JavaScript or HTML file URL.
	 * @property {string} func The function name, or empty for anonymous functions (if guessing did not work).
	 * @property {string[]?} args The arguments passed to the function, if known.
	 * @property {number=} line The line number, if known.
	 * @property {number=} column The column number, if known.
	 * @property {string[]} context An array of source code lines; the middle element corresponds to the correct line#.
	 * @memberof TraceKit
	 */
	
	/**
	 * An object representing a JavaScript stack trace.
	 * @typedef {Object} StackTrace
	 * @property {string} name The name of the thrown exception.
	 * @property {string} message The exception error message.
	 * @property {TraceKit.StackFrame[]} stack An array of stack frames.
	 * @property {string} mode 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace.
	 * @memberof TraceKit
	 */
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   ```js
	 *   s = TraceKit.computeStackTrace.ofCaller([depth])
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 *   ```
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 * Tracing example:
	 *  ```js
	 *     function trace(message) {
	 *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
	 *         var data = message + "\n";
	 *         for(var i in stackInfo.stack) {
	 *             var item = stackInfo.stack[i];
	 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
	 *         }
	 *         if (window.console)
	 *             console.info(data);
	 *         else
	 *             alert(data);
	 *     }
	 * ```
	 * @memberof TraceKit
	 * @namespace
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    var debug = false,
	        sourceCache = {};
	
	    /**
	     * Attempts to retrieve source code via XMLHttpRequest, which is used
	     * to look up anonymous function names.
	     * @param {string} url URL of source code.
	     * @return {string} Source contents.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function loadSource(url) {
	        if (!TraceKit.remoteFetching) { //Only attempt request if remoteFetching is on.
	            return '';
	        }
	        try {
	            var getXHR = function() {
	                try {
	                    return new window.XMLHttpRequest();
	                } catch (e) {
	                    // explicitly bubble up the exception if not found
	                    return new window.ActiveXObject('Microsoft.XMLHTTP');
	                }
	            };
	
	            var request = getXHR();
	            request.open('GET', url, false);
	            request.send('');
	            return request.responseText;
	        } catch (e) {
	            return '';
	        }
	    }
	
	    /**
	     * Retrieves source code from the source code cache.
	     * @param {string} url URL of source code.
	     * @return {Array.<string>} Source contents.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function getSource(url) {
	        if (typeof url !== 'string') {
	            return [];
	        }
	
	        if (!_has(sourceCache, url)) {
	            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
	            // cross-domain errors will be triggered.
	            /*
	                Regex matches:
	                0 - Full Url
	                1 - Protocol
	                2 - Domain
	                3 - Port (Useful for internal applications)
	                4 - Path
	            */
	            var source = '';
	            var domain = '';
	            try { domain = window.document.domain; } catch (e) { }
	            var match = /(.*)\:\/\/([^:\/]+)([:\d]*)\/{0,1}([\s\S]*)/.exec(url);
	            if (match && match[2] === domain) {
	                source = loadSource(url);
	            }
	            sourceCache[url] = source ? source.split('\n') : [];
	        }
	
	        return sourceCache[url];
	    }
	
	    /**
	     * Tries to use an externally loaded copy of source code to determine
	     * the name of a function by looking at the name of the variable it was
	     * assigned to, if any.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} lineNo Line number in source code.
	     * @return {string} The function name, if discoverable.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function guessFunctionName(url, lineNo) {
	        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
	            reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
	            line = '',
	            maxLines = 10,
	            source = getSource(url),
	            m;
	
	        if (!source.length) {
	            return UNKNOWN_FUNCTION;
	        }
	
	        // Walk backwards from the first line in the function until we find the line which
	        // matches the pattern above, which is the function definition
	        for (var i = 0; i < maxLines; ++i) {
	            line = source[lineNo - i] + line;
	
	            if (!_isUndefined(line)) {
	                if ((m = reGuessFunction.exec(line))) {
	                    return m[1];
	                } else if ((m = reFunctionArgNames.exec(line))) {
	                    return m[1];
	                }
	            }
	        }
	
	        return UNKNOWN_FUNCTION;
	    }
	
	    /**
	     * Retrieves the surrounding lines from where an exception occurred.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} line Line number in source code to center around for context.
	     * @return {?Array.<string>} Lines of source code.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function gatherContext(url, line) {
	        var source = getSource(url);
	
	        if (!source.length) {
	            return null;
	        }
	
	        var context = [],
	            // linesBefore & linesAfter are inclusive with the offending line.
	            // if linesOfContext is even, there will be one extra line
	            //   *before* the offending line.
	            linesBefore = Math.floor(TraceKit.linesOfContext / 2),
	            // Add one extra line if linesOfContext is odd
	            linesAfter = linesBefore + (TraceKit.linesOfContext % 2),
	            start = Math.max(0, line - linesBefore - 1),
	            end = Math.min(source.length, line + linesAfter - 1);
	
	        line -= 1; // convert to 0-based index
	
	        for (var i = start; i < end; ++i) {
	            if (!_isUndefined(source[i])) {
	                context.push(source[i]);
	            }
	        }
	
	        return context.length > 0 ? context : null;
	    }
	
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    /**
	     * Determines where a code fragment occurs in the source code.
	     * @param {RegExp} re The function definition.
	     * @param {Array.<string>} urls A list of URLs to search.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function findSourceInUrls(re, urls) {
	        var source, m;
	        for (var i = 0, j = urls.length; i < j; ++i) {
	            if ((source = getSource(urls[i])).length) {
	                source = source.join('\n');
	                if ((m = re.exec(source))) {
	
	                    return {
	                        'url': urls[i],
	                        'line': source.substring(0, m.index).split('\n').length,
	                        'column': m.index - source.lastIndexOf('\n', m.index) - 1
	                    };
	                }
	            }
	        }
	
	        return null;
	    }
	
	    /**
	     * Determines at which column a code fragment occurs on a line of the
	     * source code.
	     * @param {string} fragment The code fragment.
	     * @param {string} url The URL to search.
	     * @param {(string|number)} line The line number to examine.
	     * @return {?number} The column number.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function findSourceInLine(fragment, url, line) {
	        var source = getSource(url),
	            re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
	            m;
	
	        line -= 1;
	
	        if (source && source.length > line && (m = re.exec(source[line]))) {
	            return m.index;
	        }
	
	        return null;
	    }
	
	    /**
	     * Determines where a function was defined within the source code.
	     * @param {(Function|string)} func A function reference or serialized
	     * function definition.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function findSourceByFunctionBody(func) {
	        if (_isUndefined(window && window.document)) {
	            return;
	        }
	
	        var urls = [window.location.href],
	            scripts = window.document.getElementsByTagName('script'),
	            body,
	            code = '' + func,
	            codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            re,
	            parts,
	            result;
	
	        for (var i = 0; i < scripts.length; ++i) {
	            var script = scripts[i];
	            if (script.src) {
	                urls.push(script.src);
	            }
	        }
	
	        if (!(parts = codeRE.exec(code))) {
	            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
	        }
	
	        // not sure if this is really necessary, but I don’t have a test
	        // corpus large enough to confirm that and it was in the original.
	        else {
	            var name = parts[1] ? '\\s+' + parts[1] : '',
	                args = parts[2].split(',').join('\\s*,\\s*');
	
	            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
	            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
	        }
	
	        // look for a normal function definition
	        if ((result = findSourceInUrls(re, urls))) {
	            return result;
	        }
	
	        // look for an old-school event handler function
	        if ((parts = eventRE.exec(code))) {
	            var event = parts[1];
	            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);
	
	            // look for a function defined in HTML as an onXXX handler
	            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');
	
	            if ((result = findSourceInUrls(re, urls[0]))) {
	                return result;
	            }
	
	            // look for ???
	            re = new RegExp(body);
	
	            if ((result = findSourceInUrls(re, urls))) {
	                return result;
	            }
	        }
	
	        return null;
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?TraceKit.StackTrace} Stack trace information.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (!ex.stack) {
	            return null;
	        }
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	
	            // Used to additionally parse URL/line/column from eval frames
	            isEval,
	            geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
	            chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,
	
	            lines = ex.stack.split('\n'),
	            stack = [],
	            submatch,
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = chrome.exec(lines[i]))) {
	                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	                isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	                    // throw out eval line/column and use top-most line/column number
	                    parts[2] = submatch[1]; // url
	                    parts[3] = submatch[2]; // line
	                    parts[4] = submatch[3]; // column
	                }
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ( parts = winjs.exec(lines[i]) ) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = gecko.exec(lines[i]))) {
	                isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	                    // throw out eval line/column and use top-most line number
	                    parts[3] = submatch[1];
	                    parts[4] = submatch[2];
	                    parts[5] = null; // no column when eval
	                } else if (i === 0 && !parts[5] && !_isUndefined(ex.columnNumber)) {
	                    // FireFox uses this awesome columnNumber property for its top frame
	                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	                    // so adding 1
	                    // NOTE: this hack doesn't work if top-most frame is eval
	                    stack[0].column = ex.columnNumber + 1;
	                }
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = guessFunctionName(element.url, element.line);
	            }
	
	            element.context = element.line ? gatherContext(element.url, element.line) : null;
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (stack[0] && stack[0].line && !stack[0].column && reference) {
	            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
	        }
	
	        return {
	            'mode': 'stack',
	            'name': ex.name,
	            'message': ex.message,
	            'stack': stack
	        };
	    }
	
	    /**
	     * Computes stack trace information from the stacktrace property.
	     * Opera 10+ uses this property.
	     * @param {Error} ex
	     * @return {?TraceKit.StackTrace} Stack trace information.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function computeStackTraceFromStacktraceProp(ex) {
	        // Access and store the stacktrace property before doing ANYTHING
	        // else to it because Opera is not very good at providing it
	        // reliably in other circumstances.
	        var stacktrace = ex.stacktrace;
	        if (!stacktrace) {
	            return;
	        }
	
	        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i,
	            opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i,
	            lines = stacktrace.split('\n'),
	            stack = [],
	            parts;
	
	        for (var line = 0; line < lines.length; line += 2) {
	            var element = null;
	            if ((parts = opera10Regex.exec(lines[line]))) {
	                element = {
	                    'url': parts[2],
	                    'line': +parts[1],
	                    'column': null,
	                    'func': parts[3],
	                    'args':[]
	                };
	            } else if ((parts = opera11Regex.exec(lines[line]))) {
	                element = {
	                    'url': parts[6],
	                    'line': +parts[1],
	                    'column': +parts[2],
	                    'func': parts[3] || parts[4],
	                    'args': parts[5] ? parts[5].split(',') : []
	                };
	            }
	
	            if (element) {
	                if (!element.func && element.line) {
	                    element.func = guessFunctionName(element.url, element.line);
	                }
	                if (element.line) {
	                    try {
	                        element.context = gatherContext(element.url, element.line);
	                    } catch (exc) {}
	                }
	
	                if (!element.context) {
	                    element.context = [lines[line + 1]];
	                }
	
	                stack.push(element);
	            }
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        return {
	            'mode': 'stacktrace',
	            'name': ex.name,
	            'message': ex.message,
	            'stack': stack
	        };
	    }
	
	    /**
	     * NOT TESTED.
	     * Computes stack trace information from an error message that includes
	     * the stack trace.
	     * Opera 9 and earlier use this method if the option to show stack
	     * traces is turned on in opera:config.
	     * @param {Error} ex
	     * @return {?TraceKit.StackTrace} Stack information.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function computeStackTraceFromOperaMultiLineMessage(ex) {
	        // TODO: Clean this function up
	        // Opera includes a stack trace into the exception message. An example is:
	        //
	        // Statement on line 3: Undefined variable: undefinedFunc
	        // Backtrace:
	        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
	        //         undefinedFunc(a);
	        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
	        //           zzz(x, y, z);
	        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
	        //           yyy(a, a, a);
	        //   Line 1 of function script
	        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
	        //   ...
	
	        var lines = ex.message.split('\n');
	        if (lines.length < 4) {
	            return null;
	        }
	
	        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
	            stack = [],
	            scripts = (window && window.document && window.document.getElementsByTagName('script')),
	            inlineScriptBlocks = [],
	            parts;
	
	        for (var s in scripts) {
	            if (_has(scripts, s) && !scripts[s].src) {
	                inlineScriptBlocks.push(scripts[s]);
	            }
	        }
	
	        for (var line = 2; line < lines.length; line += 2) {
	            var item = null;
	            if ((parts = lineRE1.exec(lines[line]))) {
	                item = {
	                    'url': parts[2],
	                    'func': parts[3],
	                    'args': [],
	                    'line': +parts[1],
	                    'column': null
	                };
	            } else if ((parts = lineRE2.exec(lines[line]))) {
	                item = {
	                    'url': parts[3],
	                    'func': parts[4],
	                    'args': [],
	                    'line': +parts[1],
	                    'column': null // TODO: Check to see if inline#1 (+parts[2]) points to the script number or column number.
	                };
	                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
	                var script = inlineScriptBlocks[parts[2] - 1];
	                if (script) {
	                    var source = getSource(item.url);
	                    if (source) {
	                        source = source.join('\n');
	                        var pos = source.indexOf(script.innerText);
	                        if (pos >= 0) {
	                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
	                        }
	                    }
	                }
	            } else if ((parts = lineRE3.exec(lines[line]))) {
	                var url = window.location.href.replace(/#.*$/, '');
	                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[line + 1]));
	                var src = findSourceInUrls(re, [url]);
	                item = {
	                    'url': url,
	                    'func': '',
	                    'args': [],
	                    'line': src ? src.line : parts[1],
	                    'column': null
	                };
	            }
	
	            if (item) {
	                if (!item.func) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	                var context = gatherContext(item.url, item.line);
	                var midline = (context ? context[Math.floor(context.length / 2)] : null);
	                if (context && midline.replace(/^\s*/, '') === lines[line + 1].replace(/^\s*/, '')) {
	                    item.context = context;
	                } else {
	                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
	                    item.context = [lines[line + 1]];
	                }
	                stack.push(item);
	            }
	        }
	        if (!stack.length) {
	            return null; // could not parse multiline exception message as Opera stack trace
	        }
	
	        return {
	            'mode': 'multiline',
	            'name': ex.name,
	            'message': lines[0],
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {TraceKit.StackTrace} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = guessFunctionName(initial.url, initial.line);
	            }
	
	            if (!initial.context) {
	                initial.context = gatherContext(initial.url, initial.line);
	            }
	
	            var reference = / '([^']+)' /.exec(message);
	            if (reference) {
	                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        stackInfo.stack[0].context = initial.context;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {TraceKit.StackTrace=} Stack trace information.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'args': [],
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'));
	              } catch (e) { }
	            }
	
	            if ((source = findSourceByFunctionBody(curr))) {
	                item.url = source.url;
	                item.line = source.line;
	
	                if (item.func === UNKNOWN_FUNCTION) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	
	                var reference = / '([^']+)' /.exec(ex.message || ex.description);
	                if (reference) {
	                    item.column = findSourceInLine(reference[1], source.url, source.line);
	                }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'mode': 'callers',
	            'name': ex.name,
	            'message': ex.message,
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     * @memberof TraceKit.computeStackTrace
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            // This must be tried first because Opera 10 *destroys*
	            // its stacktrace property if you try to access the stack
	            // property first!!
	            stack = computeStackTraceFromStacktraceProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromOperaMultiLineMessage(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'mode': 'failed'
	        };
	    }
	
	    /**
	     * Logs a stacktrace starting from the previous call and working down.
	     * @param {(number|string)=} depth How many frames deep to trace.
	     * @return {TraceKit.StackTrace} Stack trace information.
	     * @memberof TraceKit.computeStackTrace
	     */
	    function computeStackTraceOfCaller(depth) {
	        depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
	        try {
	            throw new Error();
	        } catch (ex) {
	            return computeStackTrace(ex, depth + 1);
	        }
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	    computeStackTrace.guessFunctionName = guessFunctionName;
	    computeStackTrace.gatherContext = gatherContext;
	    computeStackTrace.ofCaller = computeStackTraceOfCaller;
	    computeStackTrace.getSource = getSource;
	
	    return computeStackTrace;
	}());
	
	/**
	 * Extends support for global error handling for asynchronous browser
	 * functions. Adopted from Closure Library's errorhandler.js
	 * @memberof TraceKit
	 */
	TraceKit.extendToAsynchronousCallbacks = function () {
	    var _helper = function _helper(fnName) {
	        var originalFn = window[fnName];
	        window[fnName] = function traceKitAsyncExtension() {
	            // Make a copy of the arguments
	            var args = _slice.call(arguments);
	            var originalCallback = args[0];
	            if (typeof (originalCallback) === 'function') {
	                args[0] = TraceKit.wrap(originalCallback);
	            }
	            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	            // also only supports 2 argument and doesn't care what "this" is, so we
	            // can just call the original function directly.
	            if (originalFn.apply) {
	                return originalFn.apply(this, args);
	            } else {
	                return originalFn(args[0], args[1]);
	            }
	        };
	    };
	
	    _helper('setTimeout');
	    _helper('setInterval');
	};
	
	//Default options:
	if (!TraceKit.remoteFetching) {
	    TraceKit.remoteFetching = true;
	}
	if (!TraceKit.collectWindowErrors) {
	    TraceKit.collectWindowErrors = true;
	}
	if (!TraceKit.linesOfContext || TraceKit.linesOfContext < 1) {
	    // 5 lines before, the offending line, 5 lines after
	    TraceKit.linesOfContext = 11;
	}
	
	// UMD export
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (TraceKit), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports && window.module !== module) {
	    module.exports = TraceKit;
	} else {
	    window.TraceKit = TraceKit;
	}
	
	}(typeof window !== 'undefined' ? window : global));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	"use strict";function _classCallCheck(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(exports,"__esModule",{value:!0});var _createClass=function(){function e(e,o){for(var n=0;n<o.length;n++){var l=o[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l)}}return function(o,n,l){return n&&e(o.prototype,n),l&&e(o,l),o}}(),DefaultLogger=exports.DefaultLogger=function(){function e(){_classCallCheck(this,e)}return _createClass(e,[{key:"logInfo",value:function(){console.info.apply(console,arguments)}},{key:"logDebug",value:function(){console.debug.apply(console,arguments)}},{key:"logError",value:function(){console.error.apply(console,arguments)}},{key:"logWarn",value:function(){console.warn.apply(console,arguments)}}]),e}();
	//# sourceMappingURL=defaultLogger.js.map


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	"use strict";function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(exports,"__esModule",{value:!0});var DefaultStorage=exports.DefaultStorage=function t(){var e=this;_classCallCheck(this,t),this.getItem=function(t){return Promise.resolve(e.storage.getItem(t))},this.setItem=function(t,r){return Promise.resolve(e.storage.setItem(t,r))},this.getObject=function(t){return e.getItem(t).then(function(t){return t&&JSON.parse(t)})},this.setObject=function(t,r){return e.setItem(t,JSON.stringify(r))},this.storage=window.SyncedStorage||window.localStorage};
	//# sourceMappingURL=defaultStorage.js.map


/***/ }),

/***/ 174:
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var SESSION_KEY=exports.SESSION_KEY="lfrsession",MESSAGES=exports.MESSAGES={please_enter_credentials:"Bitte geben Sie den Benutzernamen und das Passwort ein!",login_successful:"Anmeldung erfolgreich!"},DEFAULT_OPTIONS=exports.DEFAULT_OPTIONS={loginServicePath:"/api/jsonws/js-client-portlet.authentication/get-access-info",isSessionRequired:!0,useBasicAuth:!0,sessionSharing:!1,autoInstall:!0,guestIsValidSession:!0,refreshSessionAfter:0,autoSessionValidation:!1},DEFAULT_MOBILE_OPTIONS=exports.DEFAULT_MOBILE_OPTIONS={registerMethod:"/mobileapps.installation/register-installation.7",unregisterMethod:"/mobileapps.installation/unregister-installation.2",errorLoggingMethod:"/mobileapps.event/add.6",deviceFamily:{android:{senderID:null,variantUuid:null,variantSecret:null},ios:{variantUuid:null,variantSecret:null},wp8:{variantUuid:null,variantSecret:null},browser:{variantUuid:null,variantSecret:null}}},STATE=exports.STATE={INIT:"INIT",INITIALIZED:"INITIALIZED",NO_SESSION:"NO_SESSION",REFRESH_PREVIOUS_SESSION_REQUESTED:"REFRESH_PREVIOUS_SESSION_REQUESTED",SESSION_REQUESTED:"SESSION_REQUESTED",LOGGED_IN:"LOGGED_IN",SHOULD_INSTALL:"SHOULD_INSTALL",INSTALL_REQUESTED:"INSTALL_REQUESTED",INSTALLED:"INSTALLED"},EVENTS=exports.EVENTS={STATE_CHANGED:"stateChanged",NO_SESSION:"noSession",INIT:"init",INSTALL:"install",PUSH_REGISTERED:"pushRegistered",PUSH_REGISTRATION_FAILED:"pushRegisteredFailed",NOTIFICATION:"notification",LOGIN:"login",LOGIN_FAIL:"login_fail",LOGOUT:"logout"};
	//# sourceMappingURL=Constants.js.map


/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var xhrResponseTypeSupport=exports.xhrResponseTypeSupport=function(){var e=new XMLHttpRequest;if("responseType"in e){try{e.responseType="json"}catch(e){console.warn("XMLHttpRequest.responseType = 'json' not supported.")}if("json"===e.responseType)return!0}},responseToJSON=exports.responseToJSON=xhrResponseTypeSupport()?function(e){return e}:function(e){return JSON.parse(e)};
	//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 176:
/***/ (function(module, exports) {

	"use strict";function _classCallCheck(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(e){for(var o=1;o<arguments.length;o++){var r=arguments[o];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},_createClass=function(){function e(e,o){for(var r=0;r<o.length;r++){var n=o[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(o,r,n){return r&&e(o.prototype,r),n&&e(o,n),o}}(),FileUploader=exports.FileUploader=function(){function e(o,r){_classCallCheck(this,e),this.lrc=o,this.uploadServiceUrl=r}return _createClass(e,[{key:"safeFileName",value:function(e){var o=e.substr(e.lastIndexOf("/")+1),r=o.lastIndexOf("?");return r>-1&&(o=o.substring(0,r)),o}},{key:"fileUpload",value:function(e,o,r,n){var s=this,t=n.o,a=n.onProgress;return new Promise(function(n,l){function i(){return" -> fileUpload("+e+", "+o+", params: "+JSON.stringify(r)+", "+JSON.stringify(r)+")"}function p(o){try{var r=o.response&&JSON.parse(o.response)||{};r.exception?(console.error("Upload error. Result: "+o.response+i()),l(r.exception)):(console.info("Upload "+e+" successful, response:"+o.response),n(r))}catch(e){console.error("Upload error - Error = "+e.message+" with result: "+o.response+i()),l(e)}}function c(e){console.info("onprogress: "+JSON.stringify(e)),a&&a(e)}if(r=r||{},console.info("Upload: "+e),"undefined"!=typeof FileUploadOptions){var u=e.uri,f=new FileUploadOptions;f.fileKey="file",f.fileName=e.name||s.safeFileName(u),f.mimeType=e.type||t&&t.type||"application/octet-stream",f.headers={Connection:"close"},f.params=r,f=_extends({},f,t),s.lrc._setAuth(f);var d=new FileTransfer;d.onprogress=c,d.upload(u,o,function(e){n(JSON.parse(e.response))},function(e){console.error("Upload error: Code = "+e.code+i()),l(e)},f)}else if(e instanceof Blob||"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&e instanceof Object){console.info("Start XHR2 File upload!");var v=new XMLHttpRequest;v.open("POST",o,!0),v.onload=function(e){e.response=v.response,p(e)},v.upload.addEventListener("progress",c,!1),v.upload.addEventListener("error",function(o){console.error("Upload error "+e+" - : Loaded data = "+o.loaded+i()),l(o)},!1);var h=new FormData;h.append("file",e);for(var g in r)h.append(g,r[g]);s.lrc._setAuth(v),v.send(h)}else if(0===(e+"").indexOf("blob:")||0===(e+"").indexOf("moz-filedata:")){var y=new XMLHttpRequest;y.open("GET",e,!0),y.responseType="blob",y.onload=function(){if(200===y.status){var i=y.response,p=e.split("/");r.fileName=p[p.length-1]+".png",console.log("BLOB",i,o,r),s.fileUpload(i,o,r,{o:t,onProgress:a}).then(n,l)}else console.error("Blob upload "+e+" - fail! Status: "+s.status),l()},y.onerror=function(e){l(e)},y.send()}else console.error("Unknown upload type: ",e," o:",JSON.stringify(t)),l("Unknown upload type: ",e)})}},{key:"upload",value:function(e,o){var r=o.options,n=o.params,s=o.onProgress,t=this.lrc.getServerUrl()+"/api/jsonws"+this.uploadServiceUrl;return this.lrc.options&&this.lrc.options.useBasicAuth||(t=t+"?p_auth="+this.lrc._getAuthToken()),this.fileUpload(e,t,n,{o:r,onProgress:s})}}]),e}();
	//# sourceMappingURL=upload.js.map


/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// lwr-client.js